<template>
  <div>
    <!-- Waiver Setup Data -->

    <div class="modal fade waiver-setup-modal" tabindex="-1" role="dialog" aria-labelledby="waiverSetupModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="row" >
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white w-100 border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title text-capitalize">
                    Waiver Setup
                  </h4>
                  <div class="d-flex">
                    <button data-bs-toggle="modal" data-bs-target=".add-waiver-modal" type="button" class="btn btn-success text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add Waiver</span>
                    </button>
                  </div>
                </div>
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-striped table-nowrap table-hover dt-responsive contacts-table" id="">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">Name</th>
                        <th>Gazette Number</th>
                        <th>Gazette Date</th>
                        <th>Waiver %</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Eligibility</th>
                        <th>Status</th>
                        <th>Created By</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody class="text-capitalize">
                      <tr :key="index" v-for="(item, index) in waivers">
                        <td>{{item.name}}</td>
                        <td>{{item.gazette_number}}</td>
                        <td>{{formatDate(item.gazette_date)}}</td>
                        <td>{{item.waiver_percentage}}%</td>
                        <td>{{formatDate(item.start_date)}}</td>
                        <td>{{formatDate(item.end_date)}}</td>
                        <td>
                          <span v-if="item.eligibility_type === 'all'" class="badge rounded-pill bg-info text-uppercase">All Charges</span>
                          <span v-else class="badge rounded-pill bg-warning text-uppercase">Arrears Only</span>
                        </td>
                        <td>
                          <span v-if="item.status === 'active'" class="badge rounded-pill bg-success text-uppercase">Active</span>
                          <span v-else-if="item.status === 'inactive'" class="badge rounded-pill bg-danger text-uppercase">Inactive</span>
                          <span v-else class="badge rounded-pill bg-warning text-uppercase">Scheduled</span>
                        </td>
                        <td>{{item.created_by}}</td>
                        <td>
                          <div class="dropdown">
                            <button role="button" data-bs-toggle="dropdown" aria-haspopup="true" class="btn btn-sm btn-warning text-black waves-effect btn-label waves-light text-uppercase"><i class="mdi mdi-arrow-down-drop-circle label-icon"></i> More Options</button>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a @click="selectWaiverForEdit(item)" class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target=".add-waiver-modal"><i class="font-size-15 mdi mdi-file-document-edit me-3"></i>Edit</a>
                              <a @click="selectWaiverForStatusChange(item)" class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target=".change-status-modal"><i class="font-size-15 mdi mdi-toggle-switch me-3"></i>Change Status</a>
                              <a @click="deleteWaiver(item.id)" class="dropdown-item" href="#"><i class="font-size-15 mdi mdi-delete-alert me-3"></i>Delete</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="10">{{waivers.length}} Waiver Setups</th>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Loading indicator -->
                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center"
                         v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait
                          and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <!-- No results message -->
                    <div class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center"
                         v-if="waivers.length < 1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'assets/images/no-results.png'" alt="No search results"
                             class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter
                        criteria. Please try using different keywords or filters.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example"
                       class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                <span class="pr-3 pb-0 mb-0 font-13px">
                  <span>Rows Per Page</span>
                </span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                      </select>
                    </div>
                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a :disabled="currentPage === 1" @click="prevPage" class="page-link"
                           tabindex="-1">Previous</a>
                      </li>
                      <li :class="{ active: currentPage === page }" :key="page" class="page-item"
                          v-for="page in pagination(currentPage, totalPages, 3)">
                        <span class="page-link" v-if="page === '...'">{{ page }}</span>
                        <a @click="goToPage(page)" class="page-link" v-else>{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a :disabled="currentPage === totalPages" @click="nextPage"
                           class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>



    <!-- Add Waiver Modal -->
    <div class="modal fade add-waiver-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="myLargeModalLabel">{{isEditMode ? 'Edit Waiver' : 'Add New Waiver'}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-info">
                  <p>This waiver setup will be applied to land rates based on the selected parameters.</p>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-3">
                  <label for="waiverName">Waiver Name</label>
                  <input v-model="waiver.name" type="text" class="form-control" id="waiverName" placeholder="Enter waiver name">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="gazetteNumber">Gazette Notice Number</label>
                  <input v-model="waiver.gazette_number" type="text" class="form-control" id="gazetteNumber" placeholder="Enter gazette notice number">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="gazetteDate">Gazette Notice Date</label>
                  <input v-model="waiver.gazette_date" type="date" class="form-control" id="gazetteDate">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="waiverPercentage">Waiver Percentage (%)</label>
                  <input v-model="waiver.waiver_percentage" type="number" min="0" max="100" class="form-control" id="waiverPercentage" placeholder="Enter waiver percentage">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="eligibilityType">Eligibility Type</label>
                  <select v-model="waiver.eligibility_type" class="form-select" id="eligibilityType">
                    <option value="penalties">Penalties</option>
                  </select>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="startDate">Start Date</label>
                  <input v-model="waiver.start_date" type="date" class="form-control" id="startDate">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="endDate">End Date</label>
                  <input v-model="waiver.end_date" type="date" class="form-control" id="endDate">
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="status">Status</label>
                  <select v-model="waiver.status" class="form-select" id="status">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="scheduled">Scheduled</option>
                  </select>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-3">
                  <label for="description">Description</label>
                  <textarea v-model="waiver.description" class="form-control" id="description" rows="3" placeholder="Enter waiver description"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="saveWaiver()" type="button" class="btn btn-primary" data-bs-dismiss="modal">
              <i class="bx bx-check font-size-16 align-middle me-2"></i> {{isEditMode ? 'Update' : 'Save'}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Change Status Modal -->
    <div class="modal fade change-status-modal" tabindex="-1" role="dialog" aria-labelledby="changeStatusModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="changeStatusModalLabel">Change Waiver Status</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-info">
                  <p><i class="mdi mdi-information-outline me-2"></i> You are about to change the status of waiver: <strong>{{ selectedWaiver.name }}</strong>.</p>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-3">
                  <label for="newStatus">Select New Status</label>
                  <select v-model="selectedWaiver.status" class="form-select" id="newStatus">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="scheduled">Scheduled</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="updateWaiverStatus()" type="button" class="btn btn-primary" data-bs-dismiss="modal">
              <i class="mdi mdi-content-save me-1"></i> Update Status
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { execute, landRate } from "@/api";
import moment from "moment";

export default {
  name: "WaiverSetup",
  data() {
    return {
      waivers: [],
      waiver: {
        id: null,
        name: '',
        gazette_number: '',
        gazette_date: '',
        waiver_percentage: 0,
        start_date: '',
        end_date: '',
        eligibility_type: 'all',
        status: 'inactive',
        description: '',
      },
      selectedWaiver: {},
      isEditMode: false,
      loading: false,
      keyword: '',
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.getWaivers();

    this.$watch('keyword', function(newValue) {
      this.keyword = newValue;
      this.getWaivers();
    });

    this.$watch('pageSize', function() {
      this.getWaivers();
      const totalItems = this.totalItems;
      const newTotalPages = Math.ceil(totalItems / this.pageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    });


  },
  methods: {
    getWaivers() {
      this.loading = true;
      this.waivers = [];

      const data = new FormData();
      data.append("function", "getWaivers");
      data.append("search", this.keyword !== undefined ? this.keyword : "");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);

      execute(data, landRate)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.waivers = res.data.data.waivers;
              this.totalItems = res.data.data.count.count;
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },
    saveWaiver() {
      const data = new FormData();
      if (this.isEditMode) {
        data.append("function", "updateWaiver");
        data.append("id", this.waiver.id);
      } else {
        data.append("function", "addWaiver");
      }

      data.append("name", this.waiver.name);
      data.append("gazette_number", this.waiver.gazette_number);
      data.append("gazette_date", this.waiver.gazette_date);
      data.append("waiver_percentage", this.waiver.waiver_percentage);
      data.append("start_date", this.waiver.start_date);
      data.append("end_date", this.waiver.end_date);
      data.append("eligibility_type", this.waiver.eligibility_type);
      data.append("status", this.waiver.status);
      data.append("description", this.waiver.description);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
              this.getWaivers();
              this.resetWaiverForm();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },
    selectWaiverForEdit(waiver) {
      this.isEditMode = true;
      this.waiver = { ...waiver };
    },
    selectWaiverForStatusChange(waiver) {
      this.selectedWaiver = { ...waiver };
    },
    updateWaiverStatus() {
      const data = new FormData();
      data.append("function", "updateWaiverStatus");
      data.append("id", this.selectedWaiver.id);
      data.append("status", this.selectedWaiver.status);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            if (res.data.success) {
              alert(res.data.message);
              this.getWaivers();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert("Error: " + e.message);
          });
    },
    deleteWaiver(id) {
      if (confirm("Are you sure you want to delete this waiver setup?")) {
        const data = new FormData();
        data.append("function", "deleteWaiver");
        data.append("id", id);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        execute(data, landRate)
            .then((res) => {
              if (res.data.success) {
                alert(res.data.message);
                this.getWaivers();
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert("Error: " + e.message);
            });
      }

    },
    resetWaiverForm() {
      this.isEditMode = false;
      this.waiver = {
        id: null,
        name: '',
        gazette_number: '',
        gazette_date: '',
        waiver_percentage: 0,
        start_date: '',
        end_date: '',
        eligibility_type: 'all',
        status: 'inactive',
        description: '',
      };
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getWaivers();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getWaivers();
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getWaivers();
      }
    }
  }
};
</script>

<style scoped>
.font-13px {
  font-size: 13px;
}
</style>